import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom';
import CustomersListTable from '../../../components/admin/customers/CustomersListTable';
import SearchFormForCustomers from '../../../components/admin/customers/SearchFormForCustomers';
import { CustomerStatus } from '../../../types/enum/customerStatus';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useCustomersByAdmin } from '../../../hooks/admin/customers.admin';
import Pagination from '../../../components/ui/Pagination';
import EmptyData from '../../../components/ui/EmptyData';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';

export default function AdminViewCustomersPage() {
    const {t} = useTranslation();
       const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const category = searchParams.get('category')??"";
    const name = searchParams.get('name')?? "";
    const phone = searchParams.get('phone')?? "";
    const email = searchParams.get('email')?? "";
    const registrationDateFrom = searchParams.get('registrationDateFrom')?? "";
    const registrationDateTo = searchParams.get('registrationDateTo')?? "";

    const {data,isError,isLoading} = useCustomersByAdmin({page:pageQuery,name,email,phone,registrationDateFrom,registrationDateTo,status:category});

    const categories = [
        { id: CustomerStatus.ACTIVE, name: t(CustomerStatus.ACTIVE) },
        { id: CustomerStatus.SUSPENDED, name: t(CustomerStatus.SUSPENDED) },
    ];

    const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };
  return (
    <Layout title={t('admin_sidebar.customers')} headline=''>
      <CategoriesSection
        selectedCategory={category}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
      />
      <SearchFormForCustomers/>
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
       {data && 
              (
                data.data.length===0 
                ?
                <EmptyData/>
                :
              <>
              <CustomersListTable customers={data.data}/>
              <Pagination
              handlePagination={handlePagination}
              totalPages={data.totalPages}
              currentPage={pageQuery}
              />
              </>
              )
              }
    </Layout>
  )
}
